import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// API resource: tio-api app/resources/api/v1/pcs_fee_disambiguation_resource.rb
// The authoritative record that a processing fee was carved off a course-cash swipe
// (tio-api#8970) — row presence is the fact, unlike the tas-assistance `digests` hint
// which is only a recommendation. Sideloaded via tas-assistances.pcs-fee-disambiguation.
const PcsFeeDisambiguationSchema = withDefaults({
  type: 'pcs-fee-disambiguation',
  fields: [
    { kind: 'attribute', name: 'program' },
    { kind: 'attribute', name: 'source' },
    { kind: 'attribute', name: 'state' },
    { kind: 'attribute', name: 'coverState' },
    { kind: 'attribute', name: 'grossAmount' },
    { kind: 'attribute', name: 'feeAmount' },
    { kind: 'attribute', name: 'netAmount' },
    { kind: 'attribute', name: 'feeRate' },
    { kind: 'attribute', name: 'reversedAt' },
    { kind: 'attribute', name: 'coveredAt' },
    { kind: 'attribute', name: 'transitionLog' },
    { kind: 'attribute', name: 'deletedAt' },
    { kind: 'attribute', name: 'createdAt' },
    { kind: 'attribute', name: 'updatedAt' },
    {
      kind: 'belongsTo',
      name: 'tasAssistance',
      type: 'tas-assistance',
      options: { async: false, inverse: 'pcsFeeDisambiguation' },
    },
    {
      kind: 'belongsTo',
      name: 'tasApplication',
      type: 'tas-application',
      options: { async: false, inverse: null },
    },
    {
      kind: 'belongsTo',
      name: 'pcsCompany',
      type: 'pcs-company',
      options: { async: false, inverse: null },
    },
    {
      kind: 'belongsTo',
      name: 'pcsLogicalCardUsage',
      type: 'pcs-logical-card-usage',
      options: { async: false, inverse: null },
    },
  ],
});

export default PcsFeeDisambiguationSchema;
